import React ,{Component} from 'react';
import Loader from "../../../loader";
import Grid from '@material-ui/core/Grid';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import customStyle from "../../../../Assets/CSS/stylesheet_UHS";
import Button from "@material-ui/core/Button";
import customeClasses from "../Eligibility.css";
import i18n from "../../../../i18next";
import axios from 'axios';
import moment from 'moment';
import configurations from "../../../../configurations";
import {connect} from "react-redux";
import { Table, TableCell,Paper, TableBody, TableHead, TableRow, Tooltip } from '@material-ui/core';
import "../Add-ons/addOnsScreen.css"
import { renderProgramSummaryTable, renderFamilyBreakdownTable } from "../../../CommonScreens/reviewChoicesRenderers";

const StyledTableCell = withStyles(theme => (customStyle.tableCell))(TableCell);
const StyledTableRow = withStyles(theme => (customStyle.tableRow))(TableRow);

// Carrier drives which stepper/quote this session belongs to: "Sharing Programs" => UHF, "Insurance Plans" => VERA.
const getStepperTypeFromCookies = (cookiesData) => {
    return cookiesData.actionType;
};
const ACSMCheckbox = withStyles({
    root: {
        color: '#1a2c40',
        "&$checked": {
            color: '#1a2c40',
        },
        "&$disabled": {
            color: 'grey'
        }
    },
    checked: {},
    disabled: {
        color: 'grey'
    }
})(Checkbox);

const styles = props => (
    customStyle.chkEligiScreen
);

const WizardButton = withStyles(
    customStyle.viewBtn
)(Button);

const ProceedButton = withStyles(
    customStyle.proceedBtn
)(Button);
const NextButton = withStyles(
    customStyle.NextButton
)(Button);
const BackButton = withStyles(
    customStyle.backBtn
)(Button);


class ReviewChoice extends Component{
    constructor(props) {
        super(props);
        this.state = {
            headerData : [],
            addOnsBodyData : [],
            loaderShow : true,
            progress : 0,
            count : 0,
            healthTool : false,
            membersArr : [],
            check:false,
            reviewChoicesTab: 'summary',
            reviewSummaryData: null,
            reviewFamilyData: null,
            firstPaymentAmount: null,
            applicationFee: null,
            firstPaymentDateFormatted: null,
            draftDayFormatted: null,
            expandedSections: {},
        }
    }

    componentDidMount=()=> {
        sessionStorage.setItem('current_screen', String(this.props.activeStep));
        let subId = JSON.parse(localStorage.getItem('CurrentLoginUser')).id;
        axios.get(configurations.baseUrl + "/enrollment/saveCompletionStatus/" + subId + "/" + sessionStorage.getItem('current_screen'))
            .then((response) => {
                if (response && response.data.code === 200) console.log(response.data.code)
            })
            .catch((error) => console.log(error));
        this.fetchReviewChoicesData();
        this.fetchPaymentSummary();
    }

    fetchReviewChoicesData = () => {
        let cookiesData = JSON.parse(sessionStorage.getItem('STATE_PARAM')) || {};
        let subId = this.props.subId || cookiesData.subID || cookiesData.user_subId;
        let brokerId = cookiesData.brokerId;
        let stepperType = getStepperTypeFromCookies(cookiesData);
        let type = cookiesData.carrier || 'UHF'; // Default to 'UHF' if not found in cookies
        if (!subId || !brokerId) {
            this.setState({ loaderShow: false });
            return;
        }
        axios.get(configurations.baseRootUrl + '/veraenroll/api/v1/quote/review-choices/' + subId + '/' + type + '/' + brokerId + `?productType=${stepperType}`)
            .then((response) => {
                this.setState({
                    reviewSummaryData: response.data.programFees,
                    reviewFamilyData: response.data.familyBreakdown,
                    loaderShow: false,
                });
            }).catch((error) => {
                console.log(error);
                this.setState({ loaderShow: false });
            });
    }

    // firstPayment/applicationFee/draftDay drive the "Your First Payment" / "Your Recurring
    // Monthly Payment" rows atop Program Summary — same source Enrollment Summary uses.
    fetchPaymentSummary = () => {
        let cookiesData = JSON.parse(sessionStorage.getItem('STATE_PARAM')) || {};
        let subId = this.props.subId || cookiesData.subID || cookiesData.user_subId;
        if (!subId) return;
        axios.get(configurations.baseRootUrl + '/veraenroll/api/v1/setuppayment/paymentSummary/' + subId)
            .then((response) => {
                let data = response.data && response.data.response;
                if (!data) return;
                let draftDayFormatted = null;
                if (data.draftDay != null && data.effectiveDate) {
                    const computedDraftDay = moment.utc(data.effectiveDate).subtract(data.draftDay, 'days').date();
                    draftDayFormatted = computedDraftDay >= 29 ? 'last day' : moment.localeData().ordinal(computedDraftDay);
                }
                this.setState({
                    firstPaymentDateFormatted: data.firstPaymentDate ? moment.utc(data.firstPaymentDate).format('MMMM D, YYYY') : null,
                    draftDayFormatted,
                    firstPaymentAmount: typeof data.firstPayment === 'number' ? data.firstPayment : null,
                    applicationFee: typeof data.applicationFee === 'number' ? data.applicationFee : null,
                });
            })
            .catch((error) => console.log(error));
    }

    // Program Summary sections (one per plan/add-on) collapse to just their title + total row by
    // default — matching the Enrollment Summary page's "plan wise" presentation.
    toggleSection = (sectionIndex) => {
        this.setState((prevState) => ({
            expandedSections: {
                ...prevState.expandedSections,
                [sectionIndex]: prevState.expandedSections[sectionIndex] === true ? false : true,
            },
        }));
    }

    handleBack = () =>{
        this.props.onClickjumpfive();
    }

    handleProceed = (e) =>{
        if (e.detail === 1){
        this.props.onClick();
        }
    }
    renderProgramSummary() {
        return renderProgramSummaryTable({
            reviewSummaryData: this.state.reviewSummaryData,
            expandedSections: this.state.expandedSections,
            onToggleSection: this.toggleSection,
            firstPaymentAmount: this.state.firstPaymentAmount,
            applicationFee: this.state.applicationFee,
            firstPaymentDateFormatted: this.state.firstPaymentDateFormatted,
            draftDayFormatted: this.state.draftDayFormatted,
        });
    }

    renderFamilyDetails() {
        return renderFamilyBreakdownTable({ reviewFamilyData: this.state.reviewFamilyData, reviewSummaryData: this.state.reviewSummaryData });
    }

    render() {
        const { classes } = this.props;
        let currentScreen
             currentScreen = <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                    <div style={{textAlign : 'justify', width : '95%'}}>
                    {<p>
                          If you want to make changes to your selections, click on the <b>BACK</b> button at the bottom and select or unselect your choices on previous screens.

                        </p>}</div>
                </Grid>

                <Grid item xs={12} sm={12}>
                    <div style={customStyle.reviewChoicesTabsStep} className="reviewChoicesTabsResponsive">
                        <div
                            style={this.state.reviewChoicesTab === 'summary' ? customStyle.reviewChoicesTabActiveStep : customStyle.reviewChoicesTabInactiveStep}
                            className="reviewChoicesTabResponsive"
                            onClick={() => this.setState({ reviewChoicesTab: 'summary' })}
                        >{this.props.showHL? "PROGRAM": "PRODUCT"} SUMMARY</div>
                        <div
                            style={this.state.reviewChoicesTab === 'family' ? customStyle.reviewChoicesTabActiveStep : customStyle.reviewChoicesTabInactiveStep}
                            className="reviewChoicesTabResponsive"
                            onClick={() => this.setState({ reviewChoicesTab: 'family' })}
                        >FAMILY DETAILS</div>
                    </div>
                    <div style={{padding:  window.innerWidth <= 768 ? '16px' :'16px 22% 16px 16px', backgroundColor: '#fff'}}>{this.state.reviewChoicesTab === 'summary' ? this.renderProgramSummary() : this.renderFamilyDetails()}</div>
                </Grid>
            </Grid>


        return (
            <div style={{flexGrow: 1, display: 'flex', flexDirection: 'column'}}>
                {
                    this.state.loaderShow ? <Loader></Loader> : ''
                }
                <Grid container style={{ fontFamily : 'Roboto, Arial, Helvetica, sans-serif', fontSize : '14px', flexDirection: 'column', flex: '1 1 auto'}}>


                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        {currentScreen}
                    </Grid>
                    <Grid item xs={12} sm={6} style={{marginTop : 'auto'}}>
                        <div style={{display: 'flex', flexWrap: 'wrap', gap: '24px'}}>
                            <BackButton
                                          disabled={false}
                                          variant="contained"
                                          onClick={this.handleBack}>BACK
                            </BackButton>
                            <ProceedButton disabled={false}
                                           variant="contained"
                                           onClick={this.handleProceed}>PROCEED
                            </ProceedButton>
                        </div>
                    </Grid>
                </Grid>
            </div>
        );
    }
    handleAddOn(){
        if(!this.state.check)
        this.setState({check:true})
        else
        this.setState({check:false})
    }
}

const mapStateToProps = state => {
    return {
        subId: state.subId,
        email : state.email
    };
}


export default withStyles(styles)(connect(mapStateToProps)(ReviewChoice));
